var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list--unstyled hide--mobile"},_vm._l((_vm.sizes),function(size){return _c('li',{key:size.indicator,staticClass:"is--size",class:[{ 'is--active': size.indicator === _vm.plexipeople.size }, 'is--size-' + size.indicator.toLowerCase()],on:{"click":function($event){return _vm.resize(size)}}},[_c('span',{staticClass:"is--info-size"},[_vm._v(_vm._s(_vm.$t('visualization.max'))+" "+_vm._s(size.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d658a7a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlexipeopleVisualization.vue
// module id = 385
// module chunks = 0